import { Label } from "@/components/ui/label";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

interface ValidatedSelectProps {
    field: string;
    label?: string;
    value: any;
    onChange: (value: any) => void;
    error?: string;
    options: { value: string; label: string; description?: string }[];
    placeholder?: string;
    readOnly?: boolean;
    className?: string;
    renderOption?: (option: { value: string; label: string; description?: string }) => React.ReactNode;
}

export function ValidatedSelect({
    field,
    label,
    value,
    onChange,
    error,
    options,
    placeholder,
    readOnly,
    className,
    renderOption,
}: ValidatedSelectProps) {
    const selectClassName = `${error ? "border-red-500" : ""} ${className || ""}`;

    return (
        <div className={className}>
            {label && (
                <Label htmlFor={field} className="mb-1.5 block font-medium">
                    {label}
                </Label>
            )}
            <div className="w-full">
                <Select
                    value={value || ""}
                    onValueChange={onChange}
                    disabled={readOnly}
                >
                    <SelectTrigger className={selectClassName}>
                        <SelectValue placeholder={placeholder} />
                    </SelectTrigger>
                    <SelectContent>
                        {options.map((option) => (
                            <SelectItem key={option.value} value={option.value}>
                                {renderOption ? renderOption(option) : (
                                    option.description ? (
                                        <div className="flex justify-between items-center w-full">
                                            <span className="font-medium">{option.label}</span>
                                            <span className="text-neutral-600 text-xs ml-2">{option.description}</span>
                                        </div>
                                    ) : (
                                        option.label
                                    )
                                )}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
                {error && <p className="text-xs text-red-600 mt-1 break-words w-full">{error}</p>}
            </div>
        </div>
    );
}